import { ChildrenRoutingModule } from './component/children/children-routing.module';
import { ServiceAdministrationModule } from './component/service-administration/service-administration.module';
import { WorkflowsModule } from './component/system/workflows/workflows.module';
import { AccountsModule } from './component/system/accounts/accounts.module';
import { EmailDomainsModule } from './component/email-domains/email-domains.module';
import { ChildReportsModule } from './component/child-reports/child-reports.module';
import { DataMonitoringEnrollmentsComponent } from './component/data-monitoring-reports/data-monitoring-enrollments/data-monitoring-enrollments.component';
import { InaReportComponent } from './component/child-reports/ina-report/ina-report.component';
import { CommunicationEventReportComponent } from './component/child-reports/communication-event-report/communication-event-report.component';
import { PfsReportComponent } from './component/child-reports/pfs-report/pfs-report.component';
import { AcademicRiskReportComponent } from './component/child-reports/academic-risk-report/academic-risk-report.component';
import { GraduationReportComponent } from './component/child-reports/graduation-report/graduation-report.component';
import { ConfirmAccountRequestComponent } from './component/auth/account-request/confirm-account-request/confirm-account-request.component';
import { NewAccountCreationComponent } from './component/auth/new-account-creation/new-account-creation.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountRequestComponent } from './component/auth/account-request/account-request.component';
import { AuthGuard } from './guards/auth.guard';
import { CountyDropdownComponent } from './component/common-components/county/county-dropdown/county-dropdown.component';
import { DistrictComponent } from './component/common-components/district/district.component';
import { ForgotUsernameComponent } from './component/auth/forgot-username/forgot-username.component';
import { ForgotPasswordComponent } from './component/auth/forgot-password/forgot-password.component';
import { LoginComponent } from './component/auth/login/login.component';
import { RegionDropdownComponent } from './component/common-components/region/region-dropdown/region-dropdown.component';
import { ResendConfirmationCodeComponent } from './component/auth/account-request/resend-confirmation-code/resend-confirmation-code.component';
import { ChangePasswordUserProfileComponent } from './component/user-profile/change-password-user-profile/change-password-user-profile.component';
import { EditUserProfileComponent } from './component/user-profile/edit-user-profile/edit-user-profile.component';
import { ViewUserProfileComponent } from './component/user-profile/view-user-profile/view-user-profile.component';
import { CountsComponent } from './component/child-reports/counts/counts.component';
import { EditSchoolComponent } from './component/school/edit-school/edit-school.component';
import { ForgotPasswordChangeComponent } from './component/auth/forgot-password-change/forgot-password-change.component';
import { DataMonitoringReportsModule } from './component/data-monitoring-reports/data-monitoring-reports.module';

import { SearchSchoolsComponent } from './component/school/search-schools/search-schools.component';
import { EditChildComponent } from './component/children/edit-child/edit-child.component';
import { EditINAComponent } from './component/children/edit-child/ina/edit-ina/edit-ina.component';
import { CoeRoutingModule } from './component/coe/coe-routing.module';
import { SearchCoeComponent } from './component/coe/search-coe/search-coe.component';
import { QueuedComponent } from './component/work-bench/queued/queued.component';
import { TreeWithTableComponent } from './component/work-bench/tree-with-table/tree-with-table.component';
import { MyTasksComponent } from './component/work-bench/my-tasks/my-tasks.component';
import { SearchReviewlogComponent } from './component/coe/search-reviewlog/search-reviewlog.component';
import { PrintBulkCoesComponent } from './component/coe/print-bulk-coes/print-bulk-coes.component';
import { MyArchiveComponent } from './component/work-bench/my-archive/my-archive.component';
import { MyInvolvedComponent } from './component/work-bench/my-involved/my-involved.component';
import { ManageComponent } from './component/work-bench/manage/manage.component';
import { SearchChildrenComponent } from './component/children/search-children/search-children.component';
import { AccountRequestUpdateComponent } from './component/auth/account-request-update/account-request-update.component';

const routes: Routes = [
    //Default
    {
        path: '',
        component: SearchChildrenComponent,
        canActivate: [AuthGuard]
    },
    //This is for testing only. Remove once it is tested
    {
        path: 'region',
        component: RegionDropdownComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'county',
        component: CountyDropdownComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'district',
        component: DistrictComponent,
        canActivate: [AuthGuard]
    },
    // {
    //     path: 'dashboard',
    //     loadChildren: () => import('./component/dashboard/dashboard.module').then((m) => m.DashboardModule),
    //     canActivate: [AuthGuard] //, RouteGuardService
    // },
    // {
    //     path: 'dashboard/:stayOnPage',
    //     loadChildren: () => import('./component/dashboard/dashboard.module').then((m) => m.DashboardModule),
    //     canActivate: [AuthGuard] //, RouteGuardService
    // },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent
    },
    {
        path: 'forgot-username',
        component: ForgotUsernameComponent
    },
    // Account Request
    {
        path: 'account-request',
        component: AccountRequestComponent
    },
    {
        path: 'update-information/code/:emailConfirmationCode',
        component: AccountRequestUpdateComponent
    },
    {
        path: 'account-request/resend-confirmation-code',
        component: ResendConfirmationCodeComponent
    },
    {
        path: 'confirm/email/code/:emailConfirmationCode',
        component: ConfirmAccountRequestComponent
    },
    {
        path: 'accounts/password/recovery/:emailConfirmationCode',
        component: ForgotPasswordChangeComponent
    },
    {
        path: 'accounts/new/user/:emailConfirmationCode',
        component: NewAccountCreationComponent
    },
    // User Profile
    {
        path: 'account/user-profile',
        component: ViewUserProfileComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'account/user-profile/edit',
        component: EditUserProfileComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'account/user-profile/change-password',
        component: ChangePasswordUserProfileComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'school',
        loadChildren: () => import('./component/school/schools.module').then((m) => m.SchoolsModule),
        canActivate: []
    },
    {
        path: 'coe',
        loadChildren: () => import('./component/coe/coe.module').then((m) => m.CoeModule),
        canActivate: [AuthGuard] //  RouteGuardService
    },
    {
        path: 'coe-2010',
        loadChildren: () => import('./component/coe-2010/coe-2010.module').then((m) => m.Coe2010Module),
        canActivate: [AuthGuard] //  RouteGuardService
    },
    {
        path: 'coe-2017',
        loadChildren: () => import('./component/coe-2017/coe-2017.module').then((m) => m.Coe2017Module),
        canActivate: [AuthGuard] //  RouteGuardService
    },
    {
        path: 'children',
        loadChildren: () => import('./component/children/children.module').then((m) => m.ChildrenModule),
        canActivate: [AuthGuard] //  RouteGuardService
    },
    {
        path: 'system',
        loadChildren: () => import('./component/system/system.module').then((m) => m.SystemModule),
        canActivate: [AuthGuard] //RouteGuardService
    },
    {
        path: 'workflows',
        loadChildren: () => WorkflowsModule
    },
    {
        path: 'administer-services',
        loadChildren: () => ServiceAdministrationModule
    },

    // Child Reports
    {
        path: 'reports',
        loadChildren: () => ChildReportsModule,
        canActivate: [AuthGuard] //RouteGuardService
    },
    {
        path: 'data-monitoring-reports',
        loadChildren: () => DataMonitoringReportsModule,
        canActivate: [AuthGuard] //RouteGuardService
    },
    // Children
    {
        path: 'children',
        loadChildren: () => ChildrenRoutingModule,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    // System - Email Domains
    {
        path: 'email-domains',
        loadChildren: () => EmailDomainsModule
    },
    /*{
        path: 'editschool',
        component: EditSchoolComponent,
        canActivate: [AuthGuard]
    },*/
    {
        path: 'ssdp',
        loadChildren: () => import('src/app/component/ssdp/ssdp.module').then((m) => m.SsdpModule),
        canActivate: [AuthGuard] //RouteGuardService
    },
    {
        path: 'sdp',
        loadChildren: () => import('src/app/component/sdp/sdp.module').then((m) => m.SdpModule),
        canActivate: [AuthGuard] //RouteGuardService
    },
    {
        path: 'accounts',
        loadChildren: () => AccountsModule,
        canActivate: [AuthGuard]
    },
    {
        path: 'ina/edit',
        component: EditINAComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'workbench/queued',
        component: QueuedComponent,
        canActivate: [AuthGuard] // RouteGuardService
    },
    {
        path: 'workbench/my-tasks',
        component: MyTasksComponent,
        canActivate: [AuthGuard] // RouteGuardService
    },
    {
        path: 'workbench/my-archive',
        component: MyArchiveComponent,
        canActivate: [AuthGuard] // RouteGuardService
    },
    {
        path: 'workbench/manage',
        component: ManageComponent,
        canActivate: [AuthGuard] // RouteGuardService
    },
    {
        path: 'workbench/my-involved',
        component: MyInvolvedComponent,
        canActivate: [AuthGuard] // RouteGuardService
    },
    {
        path: 'workbench/tree-with-table',
        component: TreeWithTableComponent,
        canActivate: [AuthGuard] // RouteGuardService
    },
    {
        path: 'account-request',
        loadChildren: () =>
            import('src/app/component/auth/account-request-workflow/account-request-workflow.module').then((m) => m.AccountRequestWorkflowModule),
        canActivate: [AuthGuard] //RouteGuardService
    },

    { path: '**', redirectTo: '/login' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
